import { Auth } from "aws-amplify";
import {
  BACKEND_ENDPOINT,
  CREATE_DEVICE,
  UPDATE_DEVICE,
  DELETE_DEVICE,
  GET_DEVICE,
  GET_DEVICE_DETAIL,
} from "./urls_dev";
import axios from "axios";

const getToken = () => {
  const name = "VCS_TOKEN=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(name)) {
      return cookie.substring(name.length);
    }
  }

  return null;
};

export const deviceDefinition = {
  deviceId: "",
  deviceType: "THRUST_STAND",
  deviceName: "",
  deviceDescription: "",
  deviceStatus: "PENDING",
  createdBy: JSON.parse(localStorage.getItem("usda"))?.email,
  createdOn: Math.floor(Date.now() / 1000),
  updatedOn: Math.floor(Date.now() / 1000),
  isDeleted: false,
  EntityType: "DEVICE",
  Timestamp: Math.floor(Date.now() / 1000),
  ChangeLog: "created by the user",
};

export const createDevice = async (deviceData) => {
  const token = getToken();
  const currentUser = await Auth.currentAuthenticatedUser();
  
  const newDeviceData = {
    ...deviceDefinition,
    ...deviceData,
    serviceName: "thruststand",
    deviceId: `device_${Date.now()}`,
    "association:USER": [
      {
        id: "cognitoId",
        value: currentUser.attributes.sub,
        entityType: "USER",
      },
    ],
  };

  const body = {
    operation: "CREATE",
    entityType: "DEVICE",
    data: newDeviceData,
  };

  try {
    const backendUrl = `${BACKEND_ENDPOINT}${CREATE_DEVICE}`;
    const response = await axios.post(backendUrl, body, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    return {
      ...response.data,
      createdDevice: newDeviceData,
    };
  } catch (error) {
    console.error("Error creating new device:", error);
    throw new Error("Failed to create new device");
  }
};

export const getDevices = async (params = {}) => {
  const token = getToken();
  const backendUrl = `${BACKEND_ENDPOINT}${GET_DEVICE}`;

  try {
    const response = await axios.post(
      backendUrl,
      {
        operation: "LIST",
        entityType: "DEVICE",
        data: {
          parentId: JSON.parse(localStorage.getItem("usda"))?.email,
          parentType: "USER",
          limit: params.limit || 100,
          page: params.page || 1,
          lastEvaluatedKey: params.lastEvaluatedKey || null,
          requiredFields: [
            "deviceId",
            "deviceName",
            "deviceType",
            "deviceStatus",
          ],
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    
    const rawData = typeof response.data.data === "string" 
      ? JSON.parse(response.data.data) 
      : response.data;

      return rawData.data.filter(item => item.serviceName === "thruststand").map(item => ({
      id: item.deviceId,
      deviceName: item.deviceName,
      deviceStatus: item.deviceStatus,
    }));
  } catch (err) {
    console.error("Error fetching devices:", err.message || err);
    throw new Error("Unable to fetch devices: " + (err.message || "Unknown error"));
  }
};

export const getDeviceDetails = async (deviceId) => {
  if (!deviceId) {
    throw new Error("A device ID is required to fetch device details");
  }

  const token = getToken();
  const backendUrl = `${BACKEND_ENDPOINT}${GET_DEVICE_DETAIL}`;
  
  try {
    const response = await axios.post(
      backendUrl,
      {
        operation: "READ",
        entityType: "DEVICE",
        data: { deviceId, serviceName: "thruststand" },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    const responseData = typeof response.data.body === "string"
      ? JSON.parse(response.data.body)
      : response.data;
    const deviceData = typeof responseData.data === "string"
      ? JSON.parse(responseData.data)
      : responseData.data || responseData;

    return {
      id: deviceData.deviceId,
      deviceName: deviceData.deviceName,
      deviceStatus: deviceData.deviceStatus,
      isStore: deviceData.isStore !== false,
    };
  } catch (error) {
    console.error(
      "Error fetching device details:",
      error.response?.data || error.message || error
    );
    throw error;
  }
};

export const updateDevice = async (deviceData) => {
  const token = getToken();
  const backendUrl = `${BACKEND_ENDPOINT}${UPDATE_DEVICE}`;
  
  const updateData = {
    deviceId: deviceData.id,
    deviceName: deviceData.deviceName,
    deviceStatus: deviceData.deviceStatus,
    serviceName: "thruststand",
    updatedOn: Math.floor(Date.now() / 1000),
    ChangeLog: "updated by user"
  };

  try {
    const response = await axios.post(
      backendUrl,
      {
        operation: "UPDATE",
        entityType: "DEVICE",
        data: updateData,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating device:", error);
    throw error;
  }
};

export const deleteDevice = async (deviceId) => {
  const token = getToken();
  const backendUrl = `${BACKEND_ENDPOINT}${DELETE_DEVICE}`;
  
  try {
    const response = await axios.post(
      backendUrl,
      {
        operation: "DELETE",
        entityType: "DEVICE",
        data: { deviceId, serviceName: "thruststand" },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting device:", error);
    throw error;
  }
};
